"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "Flash", {
  enumerable: true,
  get: function () {
    return _Flash.default;
  }
});

_Object$defineProperty(exports, "useFlash", {
  enumerable: true,
  get: function () {
    return _FlashContext.useFlash;
  }
});

var _Flash = _interopRequireDefault(require("./Flash"));

var _FlashContext = require("./FlashContext");